<template>
<div>
    <BlockUI v-if="loading">
        <div class="loader"></div>
    </BlockUI>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-7 pt-md-12">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">
                REPORT DROPOFF
                </h1>
                <p class="text-white pb-0 px-3">
                    แสดงข้อมูลการส่งพัสดุ drop-off
                </p>
            </div>
            <div class="col-lg-4">
                <h1 class="display-3 text-white d-flex align-items-end flex-column">
                    <h3 class="text-white">
                        จำนวนพัสดุทั้งหมด {{orders.total_item}} ชิ้น
                    </h3>
                    <div class="d-flex" v-if="$USER_LOGIN.get().isShippop">
                        <ImportExcel :services="services" />
                    </div>
                </h1>
            </div>
        </div>
    </base-header>
    <div class="container-fluid mt--8 mb-5">
        <div class="card shadow">
            <div class="col-lg-12">
                <div class="row">
                    <ToolBox 
                        :services="services" 
                        :onSubmit="getOrderAPI"
                        :filters="filters"
                        :shops="shops"
                        :orders="orders"
                    />
                </div>
                 <div class="row">
                    <Table :order="orders" :onChangePage="getOrderAPI" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import ToolBox from '@/components/custom/Dropoff/Report/Orders/ToolBox'
import Table from '@/components/custom/Dropoff/Report/Orders/Table'
import ImportExcel from '@/components/custom/Dropoff/Report/Orders/ImportExcel'
import moment from 'moment'
import LocalStorageManagement from '@/constants/LocalStorageManagement'
import { setFormatEmptyValue } from '@/helpers/util'

const DATE_NOW = moment().format("YYYY-MM-DD")
export default {
    data(){
        return {
            loading: false,
            services: [],
            selectedServiceId: null,
            filters:{
                date_start: DATE_NOW,
                date_end: DATE_NOW,
                key: false,
                selectedShop: false
            },
            orders: {
                current_page: 1,
                per_page: 0,
                total_item: 0,
                limit: 20,
                data: []
            },
            date: {
                startDate: DATE_NOW,
                endDate: DATE_NOW,
                // date_excel: ""
            },
            shops: []
        }
    },
    components:{
        ToolBox,
        Table,
        ImportExcel
    },
    async mounted(){
        this.isLoading()
        await this.autoLoad()
        this.isLoaded()
    },
    methods:{
        async autoLoad(){
            let user = this.$USER_LOGIN.get()
            this.getListDropoffServices()
            if( user.isShippop || user.isSuperadmin ){
                await this.getListShopAPI()
            }
        },
        isLoading(){
            this.loading = true
        },
        isLoaded(){
            this.loading = false
        },
        setServiceId( e ){
            this.selectedServiceId = e
        },
        async getListDropoffServices(){
            const name = 'additional_service'
            let get = LocalStorageManagement.get( name )
            this.services =  Object.values(get[name].DROPOFF).filter( service => service.status === true )
        },
        async getListDropoffServicesAPI(){
            const URL_GET_SERVICE = '/service/dropoff'
            const header = {
                headers:{
                    Token: this.$TOKEN
                }
            }
            const add = await this.$http.get( 
                this.$API_URL + URL_GET_SERVICE , header 
            )
            return add
        },
        async getListShopAPI(){
            const URL_GET_SHOP = '/shop/list'
            const header = {
                headers:{
                    Token: this.$TOKEN
                }
            }
            const get = await this.$http.get( 
                this.$API_URL + URL_GET_SHOP , header 
            )
            this.shops = this.convertShopName(get.data.data)
            return this.shops
        },
        convertShopName(data){
            if (data.length < 1) {
                return []
            }

            data.forEach((v) => {
                if (v.shop_details && v.shop_details.lazada_dropoff) {
                    v.name = v.name + `\xa0(${v.shop_details.lazada_dropoff})`
                }
            })
            return data
        },
        async getOrderAPI(){
            this.isLoading()
            const URL_GET_SERVICE = '/service/dropoff/report/orders'
            const header = {
                params:{
                    date_start: this.convertDate( this.filters.startDate ),
                    date_end: this.convertDate( this.filters.endDate ),
                    key: this.filters.key,
                    shop_id: this.filters.selectedShop,
                    page: this.orders.current_page,
                    limit: this.orders.limit
                },
                headers:{
                    Token: this.$TOKEN
                }
            }
            let get = await this.$http.get( 
                this.$API_URL + URL_GET_SERVICE , header 
            )
            get.data.data.data = setFormatEmptyValue( get.data.data.data )
            this.isLoaded()
            return get.data
        },
        convertDate( date ){
            return moment( date ).format( "YYYY-MM-DD" )
        }
    }
}
</script>